module.exports = __webpack_public_path__ + "16f859b527e54ef4c757aba84595516f.svg";